export interface UrlParams {
  testId: string;
  sessionId: string;
  module: string;
  subPage: string;
  subStep?: string;
}

export enum StaticIntroType {
  Overall = "overall",
  Instructions = "instructions",
  Organisation = "organisation",
  Team = "team",
  Leadership = "leadership",
  PersonalSummary = "personal-summary",
  Leverages = "leverages",
  Challenges = "challenges",
}
